import { useGetCities } from '@entities/region';
import { TagsInput, type TagsInputProps } from '@mantine/core';

type RegionTagsInputProps = {
  placeholder?: string;
} & TagsInputProps;

export const RegionTagsInput = ({
  placeholder = 'Выберите',
  ...props
}: RegionTagsInputProps) => {
  const { data } = useGetCities();

  const displayPlaceholder =
    props.value && !!props.value.length ? '' : placeholder;

  return (
    <TagsInput
      data={data?.map(item => ({
        label: item.name,
        value: item.id.toString(),
      }))}
      variant='filled'
      limit={10}
      placeholder={displayPlaceholder}
      {...props}
    />
  );
};
